import {put, call} from 'redux-saga/effects';
import AuthActions from '../redux/AuthRedux';
import {getLanguage} from './LanguageSagas';

// process STARTUP actions
export function * startup(action) {
  yield call(getLanguage);
  yield put(AuthActions.autoLogin());
}
